import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginCredentials } from '../../models/login-credentials';
import { UtilitiesService } from './utilities.service';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { RegisterCredentials } from '../../models/register-credentials';
import { ResetPasswordCredentials } from '../../models/reset-password-credentials';
import { NavigationService } from './navigation.service';
import { ChangePasswordCredentials } from '../../models/change-password-credentials';
import { ChangeEmailCredentials } from '../../models/change-email-credentials';

@Injectable()
export class AuthService {

  constructor(
    private _route: Router,
    private _httpClient: HttpClient,
    private _utilitiesService: UtilitiesService,
    private _navigationService: NavigationService) { }

  getExpiration() {
    const expiration = localStorage.getItem('expiresAt');
    const expiresAt = JSON.parse(expiration);

    return moment.unix(expiresAt).utc();
  }

  getToken() {
    return localStorage.getItem('idToken');
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  isLoggedIn() {
    if (this.getToken() === null) {
      return false;
    }

    const loggedIn = moment().isBefore(this.getExpiration());
    if (!loggedIn) {
      this.delSession();
    }
    return loggedIn;
  }

  checkUserLoggedIn() {
    const currentPage = this._navigationService.currentPage();

    if (this.isLoggedIn()) {
      this._httpClient.get(this._utilitiesService.getAPIUrl() + 'User/LoggedIn', this._utilitiesService.httpConfig)
      .subscribe(
        data => {
          if (data) {
            if (currentPage === 'login' || currentPage === 'resetpassword' || currentPage === 'register') {
              this._navigationService.navigateTo('profile');
            }
          }
        },
        err => {
          this.delSession();
          if (currentPage !== 'login' && currentPage !== 'resetpassword' && currentPage !== 'register') {
            this._navigationService.navigateTo('login');
          }
        }
      );
    } else {
      this.delSession();
      if (currentPage !== 'login' && currentPage !== 'resetpassword' && currentPage !== 'register') {
        this._navigationService.navigateTo('login');
      }
    }
  }

  logout() {
    this.delSession();
    this._route.navigate(['login']);
  }

  login(email: string, password: string) {
    this._httpClient.post(this._utilitiesService.getAPIUrl() + 'User/Login', new LoginCredentials(email, password),
    this._utilitiesService.httpConfig).subscribe(
      data => {
        this.handleLogin(data);
        this._utilitiesService.removeAction('Login');
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  register(registerInfo: RegisterCredentials) {
    this._httpClient.post(this._utilitiesService.getAPIUrl() + 'User/Register', registerInfo, this._utilitiesService.httpConfig).subscribe(
      data => {
        this.handleLogin(data);
        this._utilitiesService.removeAction('Register');
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  sendResetPasswordMail(email: string) {
    return this._httpClient.get(
      this._utilitiesService.getAPIUrl() + 'User/Password/Reset/Mail?eMail=' + email, this._utilitiesService.httpConfig);
  }

  resetPassword(resetPasswordCredentials: ResetPasswordCredentials) {
    return this._httpClient.patch(
      this._utilitiesService.getAPIUrl() + 'User/Password/Reset', resetPasswordCredentials, this._utilitiesService.httpConfig);
  }

  changePassword(changePasswordCredentils: ChangePasswordCredentials) {
    return this._httpClient.patch(
      this._utilitiesService.getAPIUrl() + 'User/Password', changePasswordCredentils, this._utilitiesService.httpConfig);
  }

  changeEmail(changeEmailCredentils: ChangeEmailCredentials) {
    return this._httpClient.patch(
      this._utilitiesService.getAPIUrl() + 'User/UpdateEmailPortal', changeEmailCredentils, this._utilitiesService.httpConfig);
  }

  private handleLogin(data: Object) {
    this.setSession(this._utilitiesService.getData(data));
    this._route.navigate(['profile']);
  }

  private setSession(authResult) {
    // const expiresAt = moment().add(authResult.expiresAt,'second');

    localStorage.setItem('idToken', authResult.idToken);
    localStorage.setItem('accessToken', authResult.accessToken);
    localStorage.setItem('expiresAt', authResult.expiresAt);
    localStorage.setItem('userName', authResult.userName);
  }

  private delSession() {
    localStorage.removeItem('idToken');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('expiresAt');
    localStorage.removeItem('userName');
  }
}
